// Función para obtener la extensión del archivo
export const obtenerExtensionArchivo = (fileName: string) => {
    return fileName.split('.').pop()?.toLowerCase();
};
